import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { FileConflictModalComponent } from '../components/fileConflictModal.component'
import { MediaFile } from 'elements-sdk'

export interface FileConflictOptions {
  pasteFile: MediaFile,
  existingFile: MediaFile,
  applyToAll?: boolean
}

export interface ConflictResolution {
  pasteFile: MediaFile,
  resolution: 'cancel'|'skip'|'overwrite'|'rename',
  applyToAll: boolean
}

// eslint-disable-next-line @typescript-eslint/no-type-alias
export type FileConflictBox = Promise<ConflictResolution> & {
  close: () => void
}

@Injectable({ providedIn: 'root' })
export class FileConflictService {
  constructor (
    private translate: TranslateService,
    private ngbModal: NgbModal,
  ) { }

  show (options: FileConflictOptions): FileConflictBox {
    const modal = this.ngbModal.open(FileConflictModalComponent)
    modal.componentInstance.options = options
    const p = modal.result
    p['close'] = () => modal.dismiss()
    return p as FileConflictBox
  }
}
